'use client';
import { rem } from '@s7/styles';

var COMPONENT_ID = "Loader";
var sizes = {
    xl1: rem(40),
    lg1: rem(32),
    md1: rem(20),
    sm1: rem(16)
};
var borderWidths = {
    xl1: rem(5),
    lg1: rem(4),
    md1: rem(3),
    sm1: rem(2)
};
var defaultProps = {
    role: "presentation",
    size: "md1",
    color: "primary.base"
};

export { COMPONENT_ID, borderWidths, defaultProps, sizes };
